$(function () {

    // console.log(route)
    // feather.replace({
    //     'class': 'feather_icon icon',
    //     'stroke-width': 1,
    //     'color': '#b2b2b2',
    //     'stroke-linecap': 'round',
    //     'stroke-linejoin': 'round',
    // });
    // feather.icons.x.toSvg({ class: 'feather_icon', 'stroke-width': 1, color: 'red' });



    /**
     * Drop Image
     * For Single Profile / Site Logo And Others
     */
    if ($('.drop_image').length) {
        $('.drop_image').inputFileZone({
            upload_url: url + '/api/upload/images',
            file_types_allowed: ['image/jpeg', 'image/png', 'image/vnd.adobe.photoshop'],
            max_file_size: 5 * 1024 * 1024, // 5MB
            height: '100px',
            width: '100px'
        })
    }

    $('.close-sidebar-btn').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';
        $(containerElement).toggleClass(classToSwitch);

        var closeBtn = $(this);

        if (closeBtn.hasClass('is-active')) {
            closeBtn.removeClass('is-active');

        } else {
            closeBtn.addClass('is-active');
        }
    });


    $('.switch-container-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';
        $(containerElement).toggleClass(classToSwitch);

        $(this).parent().find('.switch-container-class').removeClass('active');
        $(this).addClass('active');
    });

    $('.switch-theme-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';

        if (classToSwitch == 'body-tabs-line') {
            $(containerElement).removeClass('body-tabs-shadow');
            $(containerElement).addClass(classToSwitch);
        }

        if (classToSwitch == 'body-tabs-shadow') {
            $(containerElement).removeClass('body-tabs-line');
            $(containerElement).addClass(classToSwitch);
        }

        $(this).parent().find('.switch-theme-class').removeClass('active');
        $(this).addClass('active');

    });

    $('.switch-header-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-header';

        $('.switch-header-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-header');
        $(containerElement).addClass('header-shadow ' + classToSwitch);
    });

    $('.switch-sidebar-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-sidebar';

        $('.switch-sidebar-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-sidebar');
        $(containerElement).addClass('sidebar-shadow ' + classToSwitch);
    });




    $(".open-right-drawer").on('click', function () {
        $(this).addClass("is-active"),
            $(".app-drawer-wrapper").addClass("drawer-open"),
            $(".app-drawer-overlay").removeClass("d-none")
    })
    $(".drawer-nav-btn").on('click', function () {
        $(".app-drawer-wrapper").removeClass("drawer-open"),
            $(".app-drawer-overlay").addClass("d-none"),
            $(".open-right-drawer").removeClass("is-active")
    })
    $(".app-drawer-overlay").on('click', function () {
        $(this).addClass("d-none"),
            $(".app-drawer-wrapper").removeClass("drawer-open"),
            $(".open-right-drawer").removeClass("is-active")
    }),
        $(".mobile-toggle-nav").on('click', function () {
            $(this).toggleClass("is-active"),
                $(".app-container").toggleClass("sidebar-mobile-open")
        }),
        $(".mobile-toggle-header-nav").on('click', function () {
            $(this).toggleClass("active"),
                $(".app-header__content").toggleClass("header-mobile-open")
        }),
        $(".mobile-app-menu-btn").on('click', function () {
            $(".hamburger", this).toggleClass("is-active"),
                $(".app-inner-layout").toggleClass("open-mobile-menu")
        });

    $("input[type=checkbox][data-toggle^=toggle]").bootstrapToggle()


    $('.mobile-toggle-header-nav').on('click', function () {
        $(this).toggleClass('active');
        $('.app-header__content').toggleClass('header-mobile-open');
    });

    $('.mobile-toggle-nav').on('click', function () {
        $(this).toggleClass('is-active');
        $('.app-container').toggleClass('sidebar-mobile-open');
    });

    $('.datepicker').each(function() {
        $(this).datepicker({
            todayHighlight: true,
            autoclose: true,
            format: 'yyyy-mm-dd',
            weekStart: 1,
            startDate: $(this).attr('start-date') ? $(this).attr('start-date') : null // reads from HTML
        });
    });

    $('input[data-toggle="monthpicker"], .monthpicker').datepicker({
        format: "MM-yyyy",
        startView: "months",
        minViewMode: "months",
        autoclose: true
    }).attr('autocomplete', 'off');

    /**
     *  data-toggle="remove" || .remove_dom
     *  can be used to delete a div on child element click
     *  params: data-target, data-confirm
     * */

    $(document).on('click', '[data-toggle="remove"], .remove_dom', function () {
        var __this = $(this)
        if (__this.data('confirm')) {
            beautify.sweetConfirm(__this.data('confirm'), 'Click ok if you want to proceed', function (confirm) {
                if (confirm) {
                    beautify.remove_dom(__this.closest(__this.attr('data-target')), __this.attr('data-parent'));
                }
            });
        } else {
            beautify.remove_dom(__this.closest(__this.attr('data-target')), __this.attr('data-parent'));
        }
    });



    /**
     * Data Toggle [clone]
     * Clone A Div
     */
    $(document).on('click', '[data-toggle="clone"]', function (e) {
        var _clone_html = '';
        var _clone_target = $(this).data('target');
        var _clone_target_class = _clone_target.replace('.', '');

        $(this).closest(_clone_target).find('.form-control.select2').select2('destroy');
        $(this).closest(_clone_target).find('[data-toggle=toggle]').bootstrapToggle('destroy')
        _clone_html = $(this).closest(_clone_target).clone();
        $(this).closest(_clone_target).find('[data-toggle=toggle]').bootstrapToggle()
        $(this).closest(_clone_target).find('.form-control.select2').select2({
            theme: "bootstrap4",
            width: '100%'
        });

        $(_clone_html).find('input').val('');
        $(_clone_html).removeClass(_clone_target_class).addClass('toggle_removable_div');
        $(_clone_html).find('label').remove();
        $(_clone_html).find('[data-toggle="clone"]').attr('data-toggle', 'remove');
        $(_clone_html).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');


        if (jQuery().select2) {
            $(_clone_html).find('.select2').select2({
                theme: "bootstrap4",
                width: '100%'
            });
        }

        $(_clone_html).find('[data-toggle=toggle]').bootstrapToggle()

        if (jQuery().datepicker) {
            $(_clone_html).find(".datepicker").datepicker({
                todayHighlight: true,
                autoclose: true,
                format: 'yyyy-mm-dd'
            })
        }

        $(_clone_html).insertAfter(_clone_target);


        mdtimepicker('.timepicker', {
            timeFormat: 'hh:mm:ss.000',
            format: 'h:mm tt',
            theme: 'teal',
            hourPadding: true
        });

    });


    $(document).on('click', '[data-toggle="remove"]', function (e) {
        $(this).closest('.toggle_removable_div').fadeOut('fast', function () {
            $(this).closest('.toggle_removable_div').remove();
        });
    });



    /**
     * Date-range Picker
     */
    var start = moment().subtract(29, 'days');
    var end = moment();

    function cb(start, end) {
        $('#daterange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        $('#daterange').attr('start', start.format('YYYY-MM-DD'));
        $('#daterange').attr('end', end.format('YYYY-MM-DD'));
        $('#daterange').trigger('change');
    }

    $('#daterange').daterangepicker({
        startDate: start,
        endDate: end,
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }, cb);

    cb(start, end);

    /**
     * Select2
     */
    $('.select2').select2({
        theme: "bootstrap4",
        width: '100%'
    });

    $('.select2-tag').select2({
        theme: "bootstrap4",
        width: '100%',
        tags: true,
    });

    $(document).on('select2:open', () => {
        // console.log("OPN>..")
        document.querySelector('.select2-search__field').focus();
    });

    let route_class_method = route.replace(/\./g, '-');
    let parts = route.split('.');

let route_class_only = parts.length >= 3
        ? parts[0] + '-' + parts[1]
        : parts[0];

    let $targetEl = $('.mm-' + route_class_method);
    console.log(route_class_method, route_class_only);
    if ($targetEl.length === 0) {
        $targetEl = $('.mm-' + route_class_only);
    }


    if ($targetEl.length) {
        $('.mm-active').removeClass('mm-active');
        $targetEl.addClass('mm-active');
        $targetEl.closest('.mm-auto_active').addClass('mm-active');
    }

    // $('.staffpicker').select2({
    //     theme: "bootstrap4",
    //     width: '100%',
    //     minimumInputLength: 3,
    //     ajax: {
    //         url: url + '/staff/find',
    //         dataType: 'json',
    //         delay: 100,
    //         data: function (params) {
    //             return {
    //                 q: params.term, // search term
    //                 page: params.page
    //             };
    //         },
    //         processResults: function (data) {
    //             return {
    //                 results: $.map(data, function (obj) {
    //                     // console.log(obj)
    //                     return {
    //                         id: obj.id,
    //                         text: obj.first_name + ' ' + obj.last_name + ' #' + obj.reference
    //                     };
    //                 })
    //             };
    //         }
    //     }
    // });


    /**
     * This will adjust datatable on initialize
     */
    $('body').on('show.bs.tab', function () {
        setTimeout(function () {
            $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
        }, 200);
    });
    setTimeout(function () {
        // console.log('Fixing...')
        $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
    }, 200);

    setTimeout(function () {
        // console.log('fixing datatable dropdown')
        var data_table_fix = $('.dataTable').DataTable();
        data_table_fix.on('draw', function () {
            var _btn_group = $(this).find('.dropdown-menu').eq(0);
            var _btn_height = _btn_group.height();

            if (($(this).height() < _btn_height + 100) && ($(window).width() >= 992)) {
                $(this).closest('.dataTables_scrollBody').removeClass('datatable_fix').addClass('datatable_fix');
            }
        });
    }, 100);


    /**
     * initialize stepper input increment / decrement
     */
    $(document).on('product-builder-loaded', function () {
        $('.increment_select').incrementSelect();

        $(document).on('change', '.image-checkbox input[type="checkbox"]', function () {
            const $li = $(this).closest('li');
            $li.toggleClass('checked', $(this).is(':checked'));
        });
        $('.image-checkbox input[type="checkbox"]:checked').each(function() {
            $(this).closest('li').addClass('checked');
        });
    });

    $('#choose-order-type').radioCardSelect({
        cardSelector: '.custom-radio-div', // default
        radioSelector: 'input[type="radio"]', // default
        selectedClass: 'selected' // default
    });


    $('#choose-duration').radioCardSelect({
        cardSelector: '.custom-radio-div', // default
        radioSelector: 'input[type="radio"]', // default
        selectedClass: 'selected' // default
    });

    $('#choose-coverage').radioCardSelect({
        cardSelector: '.custom-radio-div', // default
        radioSelector: 'input[type="radio"]', // default
        selectedClass: 'selected' // default
    });

// aaa@bbb.cc
    init_file_uploader();
	function init_file_uploader(){
		let err;
		$('.file_upload').uploader({
			multiple: true,
			ajaxConfig: {
                url: url  + '/api/upload/images',
                method: "POST",

                paramsBuilder: function (uploaderFile) {
                    let form = new FormData();
                    form.append("file", uploaderFile.file)
                    form.append("_token", csrf_token)
                    return form
                },
                ajaxRequester: function (config, uploaderFile, progressCallback, successCallback, errorCallback) {
                    $.ajax({
                    url: config.url,
                    contentType: false,
                    processData: false,
                    method: config.method,
                    data: config.paramsBuilder(uploaderFile),
                    success: function (response) {
                        successCallback(response)
                    },
                    error: function (response) {
                        console.error("Error", response)
                        errorCallback("Error")
                    },
                    xhr: function () {
                        let xhr = new XMLHttpRequest();
                        xhr.upload.addEventListener('progress', function (e) {
                            let progressRate = (e.loaded / e.total) * 100;
                            console.log(progressRate)
                            progressCallback(progressRate)
                        })
                        return xhr;
                    }
                    })
                },
                responseConverter: function (uploaderFile, response) {
                    if(response.url){
                        return {
                            url: response.url,
                            name: response.file_name,
                        }
                    }else{
                        err = response.error
                        return response.error;
                    }
                },
                inputValueFormatter: file => file.name // structure i want in text input
			},
		}).on("upload-error",function(e,s) {
			$('.upload_error').html(err)
		}).on("before-upload", function(){
			$('.upload_error').html('')
		});
	}

    $('[data-toggle="tooltip"]').tooltip();




    // Initialize intl-tel-input
    const input = document.querySelector("#phone");
    if (input){
        const defaultCountry = "gb"; // set your default country
        const allowedCountries = ["gb", "ae", "de"]; // UK and UAE
        const iti = intlTelInput(input, {
            formatOnDisplay: true,
            hiddenInput: "full_number",
            initialCountry: defaultCountry,
            onlyCountries: allowedCountries,
            nationalMode: false,            // always show full international format
            autoHideDialCode: false,        // keep the dial code visible
        });

        // Update input when country is changed, only if input is empty
        // input.addEventListener("countrychange", () => {
        //     if (!input.value) {
        //         const countryData = iti.getSelectedCountryData();
        //         if (countryData && countryData.dialCode) {
        //             input.value = "+" + countryData.dialCode;
        //         }
        //     }
        // });

        // // Optional: prevent user from deleting the + if input becomes empty
        input.addEventListener("input", () => {
            let countryData = iti.getSelectedCountryData();

            // Fallback to defaultCountry if no country is selected
            if (!countryData || !countryData.dialCode) {
                countryData = window.intlTelInputGlobals.getCountryData().find(c => c.iso2 === defaultCountry);
            }

            if (!input.value.startsWith("+") && countryData && countryData.dialCode) {
                input.value = "+" + countryData.dialCode;
                console.log(countryData);
            }
        });
    }

    /**
     * RATING AND REVIEW
     */

    $(document).on('ajax-modal-loaded', function(){
        initializeRating();
    });
    initializeRating();


    function initializeRating(){
        $(".awesome-rating").each(function(i, element){
            $(element).awesomeRating({
                valueInitial	: parseInt($(element).attr('value')),
                readonly 	    : true,
            });
        })

        if($('.rate-user').length){
            let reviewUrl = $('.rate-user').attr('href');
            let valueInitial = parseInt($('.rate-user').attr('value'));

            let rating = $(".rate-user").awesomeRating({
                valueInitial	: valueInitial,
                readonly 	    : false,
            });
            $(rating).on('rated', function(event, value){
                $.ajax({
                    url: reviewUrl,
                    method: 'POST',
                    data: {
                        comment: $('#review-comment').val().trim(),
                        rating: value,
                        _token: csrf_token,
                    },
                    success: function(data){
                        $('.rating-message')
                        .removeClass('text-success text-error')
                        .addClass(`text-${data.status}`)
                        .html(data.message);
                        $('.add-review-comment').removeClass('d-none');
                    }
                })
            });

            $(document).on('click', '#save-review', function(){
                $.ajax({
                    url: reviewUrl,
                    method: 'POST',
                    data: {
                        comment: $('#review-comment').val().trim(),
                        rating: rating.valRating(),
                        _token: csrf_token,
                    },
                    success: function(data){
                        $('.rating-message')
                        .removeClass('text-success text-error')
                        .addClass(`text-${data.status}`)
                        .html(data.message);
                        $('.add-review-comment').removeClass('d-none');
                        $('#save-review').val('Updated');
                        window.location.reload();
                    }
                })
            });
        }

    }



});
